import type { FieldsetHTMLAttributes, HTMLAttributes, LabelHTMLAttributes } from "react";

import { cn } from "../../lib/utils";

export function FieldGroup({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("grid gap-5", className)} {...props} />;
}

export function Field({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("grid gap-2", className)} {...props} />;
}

export function FieldLabel({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn("text-sm font-semibold text-foreground", className)} {...props} />;
}

export function FieldDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("m-0 text-xs leading-5 text-muted-foreground", className)} {...props} />;
}

export function FieldError({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("m-0 text-xs font-medium text-destructive", className)} role="alert" {...props} />;
}

export function FieldSet({ className, ...props }: FieldsetHTMLAttributes<HTMLFieldSetElement>) {
  return <fieldset className={cn("m-0 grid min-w-0 gap-4 border-0 p-0", className)} {...props} />;
}

export function FieldLegend({ className, ...props }: HTMLAttributes<HTMLLegendElement>) {
  return <legend className={cn("mb-1 text-sm font-semibold text-foreground", className)} {...props} />;
}
